import { Trans } from "@lingui/react/macro";
import React from "react";
import {
  Button,
  ButtonVariant,
  IconName
} from "@silversea-ssc/ui-components-react";
import { PageCtaFragment } from "types/graphql-types";
import { toButtonVariantProps } from "./buttons";

interface PageBuilderPageCTAButtonProps extends PageCtaFragment {
  defaultVariant?: ButtonVariant;
  iconName?: IconName;
}

const DefaultCTALabel = <Trans id="cta-discover-more">Discover more</Trans>;

const PageBuilderPageCTAButton: React.FC<
  React.PropsWithChildren<PageBuilderPageCTAButtonProps>
> = ({
  defaultVariant = "primary",
  page,
  variant,
  label,
  openInNewTab,
  iconName,
  ...props
}) => {
  const target = openInNewTab ? "_blank" : undefined;
  const variantOrDefault = toButtonVariantProps(variant, defaultVariant);
  return (
    <Button
      {...props}
      renderAs="a"
      href={page?.fullPath}
      {...variantOrDefault}
      dataContentPiece="page_cta_button"
      iconName={iconName}
      target={target}
    >
      {label?.localized || DefaultCTALabel}
    </Button>
  );
};

export default PageBuilderPageCTAButton;
